import React from "react";
import sanitize from "../../helpers/sanitize";


export default function RichTextRenderer({ html, className = "" }) {
  if (!html) return null;

  const normalizeHtml = (rawHtml) => {
    let normalized = rawHtml;

    // only convert numbered paragraphs that are NOT already headings
    // and don't touch anything that already has an <h> tag
    normalized = normalized.replace(
      /<p>\s*(?:<span[^>]*>)?\s*(\d+\.\s+[^<]+?)\s*(?:<\/span>)?\s*<\/p>/gi,
      (match, content) => {
        // skip if content looks like it came from inside a heading already
        return `<h3>${content}</h3>`;
      }
    );

    // strip inline styles that override color/background — these come from
    // the editor and fight your CSS (e.g. color: rgb(0,0,0); background: transparent)
    normalized = normalized.replace(
      /style="[^"]*"/gi,
      ""
    );

    return normalized;
  };

  const cleanHtml = normalizeHtml(html);

  return (
    <div
      className={`rich-text-content ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitize(cleanHtml) }}
    />
  );
}